import $ from "jquery";

const popup = () => {
    function openPopup(e) {
        const trigger = $(e.target).closest(".js-popup-open");

        if (trigger.length) {
            e.preventDefault();

            let btnTarget = trigger.attr("data-type");

            const popup = $(`.popup.${btnTarget}`);

            popup.find('input[name="item_id"]').val(trigger.attr("data-item-id") || "");
            $("body").addClass("no-scroll");
            popup.attr("aria-hidden", "false").fadeIn();
        }
    }

    function closePopup() {
        $("body").removeClass("no-scroll");
        $(".popup").attr("aria-hidden", "true").fadeOut();
    }

    $(document).click(openPopup);
    $(".js-popup-close").click(closePopup);
};

export default popup;
